import { HiddenMobile } from '../LayoutWithLeftDesktopNav/Reusable/HiddenMobile/HiddenMobile';
import { css } from '@bts-web/utils-style-engine';
import { TradeBoxSkeleton } from '../../trade/CreateTrade/AssetPageInitiateTradeBox/TradeBoxSkeleton';
import { AssetDetailsHeaderSkeleton } from '../../asset-details/AssetDetailsLoadingSkeleton.server';

export const AssetDetailsContentSkeleton = () => {
  return (
    <div className={css({ display: 'flex', width: '100%' })}>
      <AssetDetailsHeaderSkeleton />

      <HiddenMobile>
        <TradeBoxSkeleton withNav={false} />
      </HiddenMobile>
    </div>
  );
};
